// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"d8ded781","454":"efc8b580","520":"f950c17a","553":"772cb3c9","653":"916f620b","854":"e337f605","858":"792425cb"}[chunkId] + ".chunk.js";
};